import { useEffect } from "react";
import { useRouteError } from "react-router";
import { LoadError, PageSpinner } from "@/components/ui";
import { canAutoReload, isChunkError, markAutoReload } from "@/lib/chunkError";

/**
 * Shown when a route throws. A page chunk usually fails because a deploy replaced it while this tab
 * was open, and the browser remembers a failed import until the page reloads, so reload once.
 */
export function RouteError() {
  const error = useRouteError();
  const autoReload = isChunkError(error) && canAutoReload(sessionStorage, Date.now());

  useEffect(() => {
    console.error(error);
    if (autoReload) {
      markAutoReload(sessionStorage, Date.now());
      window.location.reload();
    }
  }, [error, autoReload]);

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      {autoReload ? <PageSpinner /> : <LoadError onRetry={() => window.location.reload()} />}
    </div>
  );
}
